export default __webpack_public_path__ + "static/media/rudi_bold.6a5627d2.otf";